<template>
 <div id="abo">
   <navigation :navigationPlaceholder="navigationPlaceholder"></navigation>
    <b-container fluid class="start-normal">
      <b-row>
        <b-col cols="12" v-for="entry in entries" :key="entry.uid" class="start-container">
          <div class="subpage-title">
            <h2 class="font-color-red">
              {{ entry.aboTitel }}
            </h2>
          </div>
          <div class="text-h3 redactor-with-linkicon" v-html="newLineText(entry.aboText)"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import Navigation from "@/components/_navigation";
  const axios = require("axios");

  export default {
    name: "Abo",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Femina Politica",
    // all titles will be injected into this template
    description: "Description",
  }),
  components: {
    Navigation,
  },
  data() {
    return {
      entries: [],
      navigationPlaceholder: "Abo"
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      data: {
        query: `
              query {
                entries(section: "abo") {
                  title,
                  uid
                  ... on abo_abo_Entry {
                    aboTitel,
                    aboText
                  }
                }
              }
            `,
      },
    }).then((result) => {
      let data = result.data.data.entries;
      console.log(data);

      // assign the fetched data 2 times, once for manipulation
      // once for reseting
      this.entries = data;
      this.entriesToManipulate = data;
    });
  },
  methods: {
    newLineText(el){
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    }
  }
}
</script>

<style lang="scss">

</style>